require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-planning-content-calendars.json") })
        }
      }, "path---services-planning-content-calendars");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-planning-content-calendars!./.cache/json/services-planning-content-calendars.json
// module id = 767
// module chunks = 231608221292675